// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3l8mw","title":"Header_title__2ogXN","left":"Header_left__2jej6","clinicName":"Header_clinicName__1Zw5Z"};